const OEMBED = 'https://www.youtube.com/oembed';

/**
 * Resolve a human-readable title for a YouTube URL (video, playlist, shorts, youtu.be).
 * Uses YouTube's oEmbed API (reflects request Origin for CORS).
 * @param {string} url
 * @returns {Promise<string|null>}
 */
export async function fetchYouTubeOEmbedTitle(url) {
  try {
    const u = String(url).trim();
    if (!u) return null;
    const r = await fetch(`${OEMBED}?format=json&url=${encodeURIComponent(u)}`);
    if (!r.ok) return null;
    const j = await r.json();
    const title = j?.title;
    if (typeof title === 'string' && title.trim()) return title.trim().slice(0, 200);
    return null;
  } catch {
    return null;
  }
}
